export default __webpack_public_path__ + "static/media/lv.884e7f97.svg";